'use strict';

import 'babel-polyfill';
import Header from './modules/header';
import Modal from './modules/modal';
import ScrollTrack from './modules/scroll-track';
import YoutubePlayer from './modules/youtubePlayer';
import GATracker from './modules/ga-tracker';
import Leaders from './modules/leaders';
import Locations from './modules/locations';
import Accordion from './modules/accordion';
import Statistics from './modules/statistics';
import ReportToggle from './modules/reportToggle';
import ScrollEvents from './modules/scrollEvents';
import ByTheNumbers from './modules/btnumbers';
import Cover from './modules/cover';
import Charts from './modules/charts';
import Story from './modules/story';

class App {

	constructor() {
		this.bodyEl = document.querySelector('body');
		this.leaders = [...document.querySelectorAll('.leaders')];
		this.locations = [...document.querySelectorAll('.locations')];
		this.accordions = [...document.querySelectorAll('.accordion')];
		this.statistics = [...document.querySelectorAll('.stats')];
		this.toggleBody = [...document.querySelectorAll('[data-toggle-body]')];
		this.reportToggle = document.querySelector('.report-toggle');

		this.init();
		this.hotFix();
	}

	init() {
		this.bodyEl.classList.remove('no-js');
		this.bodyEl.classList.add('js-enabled');
		this.bodyEl.classList.add('play-cover');

		this.youtubePlayer = new YoutubePlayer();
		this.scrollTrack = new ScrollTrack();
		this.modal = new Modal();

		this.gaTracker = new GATracker();
		this.header = new Header();

		this.scrollEvents = new ScrollEvents();
		this.btNumbers = new ByTheNumbers();
		this.Cover = new Cover();
		this.Charts = new Charts();

		if (this.leaders) {
			this.leaders.forEach(el => new Leaders(el));
		}

		if (this.locations) {
			this.locations.forEach(el => new Locations(el));
		}

		if (this.accordions) {
			this.accordions.forEach(el => new Accordion(el));
		}

		if (this.statistics) {
			this.statistics.forEach(el => new Statistics(el));
		}

		if (this.reportToggle) {
			new ReportToggle(this.reportToggle);
		}

		// story pages
		if (this.bodyEl.classList.contains('single-story_type')) {
			new Story();
		}
		if (this.toggleBody.length) {
  		for (var i = 0; i < this.toggleBody.length; i++) {
    		this.toggleBody[i].addEventListener('click', this.toggleBodyClass.bind(this, this.toggleBody[i]));
  		}
		}
	}


	hotFix() {
		if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
			this.bodyEl.classList.add('ie10')
			this.bodyEl.classList.add('ie-fixes')
		}
		const UAString = navigator.userAgent;
		if (UAString.indexOf("Trident") !== -1 && UAString.indexOf("rv:11") !== -1){
			this.bodyEl.classList.add('ie11')
			this.bodyEl.classList.add('ie-fixes')
		}
	}

	toggleBodyClass(el, e) {
  	const c = el.getAttribute('data-toggle-body');
  	document.body.classList.toggle(c);
	}
}

window.App = new App();
